import CrudModel from 'model-fns';
import xtend from 'xtend';
import Effects from '../../effects';
var crudModel = CrudModel('categoryID');

function CategoriesModel (api) {
    function categoriesModel () {
        return xtend(crudModel(), { hasFetched: false });
    }

    categoriesModel.effects = Effects(api.categories);

    categoriesModel.update = xtend(crudModel.update, {
        get: function (state, ev) {
            return xtend(crudModel.update.get(state, ev), {
                hasFetched: true
            });
        }
    });

    return categoriesModel;
}

export default CategoriesModel;
